import React from "react";
import { useController, Control, FieldPath, RegisterOptions, FieldValues } from "react-hook-form";
import Dropdown from "../Dropdown";
import states from "./states";

interface Props<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  onDismiss?(): void;
  rules?: RegisterOptions;
}

export default function StateDropdown<T extends FieldValues>({ control, name, rules, onDismiss }: Props<T>) {
  const {
    field: { onChange, value, ref },
    fieldState: { error },
  } = useController<T>({ control, name, rules });

  return (
    <Dropdown
      list={states}
      setValue={onChange}
      {...{ error, value, onDismiss, ref }}
      label="State"
      testID="StateDropdown"
      inputProps={{ editable: false }}
    />
  );
}
